interface BuildUrlParams {
  baseUrl: string
  path: string
  title?: string
  status?: string
}

/**
 * Constrói uma URL segura com parâmetros codificados
 * @param baseUrl - URL base (ex: https://exemplo.com)
 * @param path - Caminho da rota (ex: /commercial/contracts/forms)
 * @param title - Título que será codificado como parâmetro (Opcional)
 * @param status - Status que será codificado como parâmetro (Opcional)
 * @returns URL completa e segura
 */
export const buildCallbackUrl = ({
  baseUrl = 'http://localhost:3001',
  path,
  status,
  title
}: BuildUrlParams): string => {
  console.log('buildCallbackUrl-baseUrl', baseUrl)
  console.log('buildCallbackUrl-path', path)
  console.log('buildCallbackUrl-status', status)
  console.log('buildCallbackUrl-title', title)
  const sanitizedBaseUrl = baseUrl.replace(/\/$/, '') // Remove barra final se existir
  const sanitizedPath = path.startsWith('/') ? path : `/${path}` // Garante que path começa com barra
  let url = `${sanitizedBaseUrl}${sanitizedPath}`
  const params: string[] = []

  if (title) {
    params.push(`title=${encodeURIComponent(title)}`)
  }
  if (status) {
    params.push(`status=${encodeURIComponent(status)}`)
  }

  if (params.length > 0) {
    url += `?${params.join('&')}`
  }
  console.log('buildCallbackUrl-url', url)
  return url
}
